import { useLocation, useNavigate } from "react-router-dom";


interface MenuItem {
  path: string;
  text: string;
  icon?: React.ReactNode;
  reviewType?: 'Item' | 'Store' | 'DeliveryPerson';
  submenu?: boolean;
}

export const useForceNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const forceNavigateWithQuery = (
    item: string | MenuItem,
    isSubmenuItem: boolean = false
  ) => {
    if (typeof item === 'string') {
      if (location.pathname === item) return;
      navigate({ pathname: item });
    } else {
      if (location.pathname === item.path) return;

      // For submenu items with reviewType
      if (isSubmenuItem && item.reviewType) {
        navigate(item.path, { state: { reviewType: item.reviewType } });
      } else {
        navigate(item.path);
      }
    }
  };

  return { forceNavigateWithQuery };
};
